import { render, staticRenderFns } from "./CrEitaaDestination.vue?vue&type=template&id=520108dc&"
import script from "./CrEitaaDestination.vue?vue&type=script&lang=js&"
export * from "./CrEitaaDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports